export const COOKIE_PREFIX = "";

const API_ROOT_URL = process.env.REACT_APP_API_URL;
// const API_ROOT_URL = "http://localhost:9000/api/";

const API_ACCOUNTS_URL = `${API_ROOT_URL}accounts/`;
const API_PROFILE_URL = `${API_ROOT_URL}profile/`;
const API_CENTERS_URL = `${API_ROOT_URL}centers/`;
const API_SIDOS_URL = `${API_ROOT_URL}sidos/`;
const API_SIGGS_URL = `${API_ROOT_URL}siggs/`;


export const API_URLS = {
  AUTH: {
    LOGIN: `${API_ACCOUNTS_URL}login/`,
    LOGOUT: `${API_ACCOUNTS_URL}logout/`,
    VERIFY: `${API_ACCOUNTS_URL}token/verify/`,
    REFRESH: `${API_ACCOUNTS_URL}token/refresh/`,
  },
  USER: {
    PROFILE: `${API_PROFILE_URL}users/me/`,
    NURSEDATA: `${API_PROFILE_URL}nurse-data/`,
    BENEFICIARIES: `${API_PROFILE_URL}beneficiaries/`,
  },
  CENTER: {
    LIST:  `${API_CENTERS_URL}`,
    SEARCH: `${API_CENTERS_URL}search/`,
  },
  AREA: {
    SIDO_LIST:  `${API_SIDOS_URL}`,
    SIGG_LIST: `${API_SIGGS_URL}`,
  },
};